module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--intersport-b53293b1e81e0cea12632f04651e7b3e.jpg";